import React from 'react';
import PropTypes from 'prop-types';

import Travellers from '@shared/propTypes/Travellers';

import useTiers from '@/hooks/useTiers';
import {
  convertCashToPoints,
  convertCashToPreviousPoints,
} from '@/lib/pointsPay';
import Total from '@/propTypes/Total';
import TotalPoints from '../TotalPoints';

const PriceInPoints = ({
  total,
  travellers,
  displayTravellerTypes = false,
  textAlign = 'left',
}) => {
  const tiers = useTiers();
  const points = convertCashToPoints(total.amount, tiers).toNumber();
  const previousPoints = convertCashToPreviousPoints(total.amount).toNumber();

  return (
    <TotalPoints
      points={points}
      previousPoints={previousPoints}
      travellers={travellers}
      displayTravellerTypes={displayTravellerTypes}
      textAlign={textAlign}
    />
  );
};

PriceInPoints.propTypes = {
  total: PropTypes.shape(Total).isRequired,
  travellers: PropTypes.shape(Travellers),
  displayTravellerTypes: PropTypes.bool,
  textAlign: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};

export default PriceInPoints;
